import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67b95734"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "nav-icon fas fa-dice-d20" }, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "right fas fa-angle-left"
}
const _hoisted_3 = { class: "nav nav-treeview" }
const _hoisted_4 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-circle nav-icon" }, null, -1))

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")

  return (_ctx.isPermissionValid(_ctx.menuItem))
    ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        class: _normalizeClass(["nav-item", {'menu-open': _ctx.isMenuExtended}])
      }, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link", {'active': _ctx.isMainActive || _ctx.isOneOfChildrenActive}]),
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.handleMainMenuAction && _ctx.handleMainMenuAction(...args)))
        }, [
          _hoisted_1,
          _createElementVNode("p", null, _toDisplayString(_ctx.$t(_ctx.menuItem.name)), 1),
          (_ctx.isExpandable)
            ? (_openBlock(), _createElementBlock("i", _hoisted_2))
            : _createCommentVNode("", true)
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItem.children, (item) => {
          return (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            (_ctx.isPermissionValid(item))
              ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                  _createVNode(_component_router_link, {
                    to: item.path,
                    class: "nav-link",
                    exact: "",
                    "exact-active-class": "active"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t(item.name)), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 256))
      ], 2))
    : _createCommentVNode("", true)
}